import { render } from "./ReservationList.vue?vue&type=template&id=111480aa&scoped=true"
import script from "./ReservationList.vue?vue&type=script&lang=js"
export * from "./ReservationList.vue?vue&type=script&lang=js"

import "./ReservationList.vue?vue&type=style&index=0&id=111480aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-111480aa"]])

export default __exports__